import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import useSWR from "swr";
import { OneBtnModal } from "components/common/modal";
import { PrimaryBtn } from "components/common/button";
import {
  AccountInfoTable,
  ApplyInfoTable,
  DetailInfoTable,
} from "components/askGraveMove/detail";
import { putAskGraveMove } from "service/api/apply";
import type { IAskGraveMoveDetail } from "service/interface/apply";
import responseCodeConstant from "service/constant/responseCodeConstant";

export function AskGraveMoveDetailPage() {
  const params = useParams();
  const [detailData, setDetailData] = useState<IAskGraveMoveDetail>(
    {} as IAskGraveMoveDetail,
  );
  const [isSuccessModalVisible, setISuccessModalVisible] =
    useState<boolean>(false);
  const { data } = useSWR(`/admin/manage/askgravemove/${params.id}`);

  useEffect(() => {
  if (data) {
    setDetailData({
      ...data.data,
      memo:
        data.data.Memos[0]?.content ||
        `(날짜)

- 상담자 :
- 지역 :
- 봉분수/크기/거리 :
- 대관/운구차 :
- 석물 :
- 석회처리 :
- 포크레인 :
- 유골함 :
- 추모공원 :
- 일정 :
- 화장장 :
- 물품 :
- 기타 :`,
    });
  }
}, [data]);


  const handleMemoInput = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setDetailData((prev) => ({
      ...prev,
      memo: e.target.value,
    }));
  };

  const handleSaveBtn = async () => {
    const saveRes = await putAskGraveMove({
      askGraveMoveId: params.id,
      body: {
        status: detailData.status,
        type: detailData.type,
        burialCount: detailData.burialCount,
        buriedPeriod: detailData.buriedPeriod,
        currentAddress: detailData.currentAddress,
        moveDate: detailData.moveDate,
        moveAddress: detailData.moveAddress,
        memo: detailData.memo,
      },
    });
    if (saveRes.status === responseCodeConstant.SUCCESS.ok) {
      setISuccessModalVisible(true);
    }
  };

  return (
    <>
      <OneBtnModal
        isVisible={isSuccessModalVisible}
        setIsVisible={setISuccessModalVisible}
        title="저장 완료"
        subTitle="저장이 완료 되었습니다."
        btnLabel="확인"
        btnClick={() => {}}
      />
      <div className="h-full min-h-[100vh] w-[calc(100%-273px)] bg-[#fdfdfd]">
        <div className="mx-auto w-[1167px] p-[78px_80px_72px_64px]">
          <p className="m-0 mb-[8px] text-[16px] font-semibold leading-[20px] text-gray-4 opacity-[0.5]">
            메모리올 관리자 화면
          </p>
          <div className="flex items-center justify-between">
            <p className="m-0 text-[32px] font-medium leading-[40px] text-black">
              이장 개장 신청 정보 상세
            </p>
          </div>
          <div className="mt-[32px] flex flex-col gap-[56px] rounded-[12px] bg-white p-[48px_40px_103px_48px] shadow-[0px_0px_8px_rgba(0,0,0,0.1)]">
            <AccountInfoTable data={detailData} setData={setDetailData} />
            <ApplyInfoTable data={detailData} setData={setDetailData} />
            <DetailInfoTable data={detailData} setData={setDetailData} />
            <div>
              <p className="m-0 mb-[24px] text-[24px] font-semibold text-black">
                메모
              </p>
              <textarea
                value={detailData.memo}
                onChange={handleMemoInput}
                className="m-0 h-[201px] w-full resize-none rounded-[8px] border-[1px] border-[#dadada] bg-[#fafafa] px-[16px] py-[24px] text-M3 text-gray-5 outline-none focus:border-gray-5 focus:ring-0"
              />
              <div className="mt-[15px] flex justify-end">
                <PrimaryBtn label="저장하기" onClick={handleSaveBtn} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
